{
  "undo": "Undo",
  "redo": "Redo",
  "bold": "Bold",
  "italic": "Italic",
  "underline": "Underline",
  "strike": "Strikethrough",
  "mono": "Monospace",
  "mark": "Marked",
  "text": "Text",
  "heading": "Heading",
  "heading1": "Heading 1",
  "heading2": "Heading 2",
  "heading3": "Heading 3",
  "heading4": "Heading 4",
  "heading5": "Heading 5",
  "heading6": "Heading 6",
  "list": "List",
  "ulist": "Bullet list",
  "olist": "Ordered list",
  "list__action_sink": "Sink item",
  "list__action_lift": "Lift item",
  "list_action_disabled": "Contradicts the logic of the list",
  "checkbox": "Checkbox",
  "quote": "Quote",
  "cut": "Cut",
  "note": "Note",
  "table": "Table",
  "link": "Link",
  "code": "Code",
  "code_inline": "Inline code",
  "codeblock": "Code block",
  "image": "Image",
  "hrule": "Separator",
  "emoji": "Emoji",
  "file": "File",
  "math": "Math",
  "math_inline": "Inline math",
  "math_block": "Math block",
  "colorify": "Text color",
  "colorify__group_text": "Text",
  "colorify__color_default": "Default",
  "colorify__color_gray": "Gray",
  "colorify__color_yellow": "Yellow",
  "colorify__color_orange": "Orange",
  "colorify__color_red": "Red",
  "colorify__color_green": "Green",
  "colorify__color_blue": "Blue",
  "colorify__color_violet": "Violet",
  "more_action": "More action",
  "tabs": "Tabs",
  "mermaid": "Mermaid"
}
